import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPost } from "@/store/api/postApiData";

interface UpdatedPostsState {
  posts: Record<string, IPost>;
}

const initialState: UpdatedPostsState = {
  posts: {},
};

export const updatedPostsSlice = createSlice({
  name: "updatedPosts",
  initialState,
  reducers: {
    updatePost: (state, action: PayloadAction<IPost>) => {
      state.posts[action.payload.uid] = action.payload;
    },
  },
});

export const { updatePost } = updatedPostsSlice.actions;
export default updatedPostsSlice.reducer;
